import { createTheme } from '@mui/material';
import { colors as glebluColors, components, palette, typography } from 'gleblu-styles';

const colors = {
  ...glebluColors,
  reservationStates: {
    prepare: glebluColors.bubblegum,
    ready: glebluColors.butter,
    reserved: glebluColors.fuchsia,
    seated: glebluColors.beige,
  },
};

const scheduleGrid =
  `repeating-linear-gradient(90deg, ${palette.grey?.[400]}, ${palette.grey?.[400]} 1px, transparent 1px, transparent calc(25% - 0.25px), ` +
  `${palette.grey?.[400]}, ${palette.grey?.[400]} 1px), repeating-linear-gradient(0deg, ${palette.grey?.[400]}, ${palette.grey?.[400]} 1px, ` +
  `transparent 1px, transparent calc(100% - 1px), ${palette.grey?.[400]}, ${palette.grey?.[400]} 1px)`;

const theme = {
  ...createTheme({
    palette,
    components,
    typography,
  }),
  colors,
  ownTypography: typography,
  sizes: {
    header: {
      height: 64,
    },
    footer: {
      height: 64,
    },
    leftMenuBar: {
      width: 288,
    },
    unit: 8,
    managementCard: {
      height: 60,
    },
    managementPage: {
      schedule: {
        row: {
          height: 56,
        },
        margins: {
          left: 64,
          right: 64,
        },
        tableHeader: {
          width: 56,
        },
      },
    },
    timeSlider: {
      thumb: { width: 48, height: 32 },
      width: 48,
      height: 32,
    },
  },
  gradients: {
    tableMap: `linear-gradient(rgb(40,39,51), rgb(40,39,51) 3%, ${colors.violet} 25%, ${colors.violet} 100% )`,

    scheduleGrid: scheduleGrid,
  },
};

export type Theme = typeof theme;

export default theme;
